import React, {useState} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp} from '@fortawesome/free-brands-svg-icons';
import {constants} from "../core/data/constants";

const CTA = () => {

  const contactNumber = constants[0].contactNumbers[0][0];
  const [customMessage, setCustomMessage] = useState(
    "Hola! Gracias por Comunicarte con Flaco Digital\n\n" +
    "Si tienes alguna pregunta por favor házmela saber.\n\n" +
    "Para comenzar vamos a necesitar la siguiente información:\n\n" +
    "- Tu logo\n" +
    "- Tu nombre de página de Facebook\n" +
    "- Whatsapp de atención\n" +
    "- Cuentas de pago\n" 
  );



  const whatsappLink = `https://api.whatsapp.com/send/?phone=${encodeURIComponent(contactNumber)}&text=${encodeURIComponent(customMessage)}&type=phone_number&app_absent=0`;


  function formatPhoneNumber(phoneNumber) {
    // Remove any non-digit characters from the phone number
    const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');
  
    // Check if the cleaned phone number has 10 or more digits
    if (cleanedPhoneNumber.length >= 10) {
      return `+${cleanedPhoneNumber.slice(0, 2)} (${cleanedPhoneNumber.slice(2, 5)}) ${cleanedPhoneNumber.slice(5, 8)} ${cleanedPhoneNumber.slice(8)}`;
    } else {
      return phoneNumber; // Return the original number if it doesn't have enough digits to format
    }
  }

  const contactLinks = constants[0].contactNumbers.map((item, index) => (
    <a
      key={index}
      className="hover:text-darkaccent transition-all cursor-pointer sm:text-2xl text-base"
      href={`https://wa.me/${item[0]}`}
      target="_blank"
    >
      <FontAwesomeIcon icon={faWhatsapp} />
      {" "}{formatPhoneNumber(item[0])}
    </a>
  ));

    const openingHoursItems = constants[0].openingHours.map((item, index) => (
      <div key={index} className="flex justify-between items-center gap-5 border-b">
        <h3>{item[0]}</h3>
        <h3 className="font-light text-darkaccent">{item[1]}</h3>
      </div>
    ));
  return (
    <div className="flex flex-col  text-center text-text dark:text-darktext mb-16 w-11/12 md:w-3/4 mx-auto">
      <h2 className="sm:text-4xl text-3xl font-bold mb-6">¿Cómo Iniciar?</h2>
      <div className='mb-8'>
      <p className="sm:text-2xl text-base text-balance  mb-8">
        Da click en el botón para que podamos guiarte en los siguientes pasos.
      </p>
      <a href={whatsappLink} target="_blank" className=" px-6 py-1 sm:text-2xl text-base bg-primary dark:bg-darkprimary text-darktext dark:text-text hover:bg-primary/90 dark:hover:bg-darkprimary/90 transition-all rounded-lg">
        Comienza Ahora
      </a>
      </div>
      
<div>
      <p className="sm:text-2xl text-base text-balance mb-2">
        ¿Necesitas ayuda con algo más? Contáctanos por Whatsapp
      </p>
      {contactLinks}
      

</div>

  
    
    </div>
  )
}

export default CTA
